import { render, staticRenderFns } from "./OrderRejectNotice.vue?vue&type=template&id=1f351dcc&scoped=true"
import script from "./OrderRejectNotice.vue?vue&type=script&lang=js"
export * from "./OrderRejectNotice.vue?vue&type=script&lang=js"
import style0 from "./OrderRejectNotice.vue?vue&type=style&index=0&id=1f351dcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f351dcc",
  null
  
)

export default component.exports